window.modal_index = 2000;
window.fabriqueImagePreviewDialogSwiper = null;
window.fabriqueFabsPopupArticleSwiper = null;
window.fabriqueFabsPopupSpusSwiper = null;
window.currentClickPauseVideoElement = null;
window.currentClickfabriqueFabs = null;
window.updateCartSectionList = [
  {
    section: "cart-icon-bubble",
    updateDomIdList: ["cart-icon-bubble"],
  },
  {
    section: "fabrique-cart-drawer-section",
    updateDomIdList: [
      "fabrique-shopping-cart-drawer_header-free-shipping",
      "fabrique-goods-detail-cart-drawer_content",
      "fabrique-goods-detail-cart-drawer_footer",
    ],
  },
  {
    section: "main-cart-items",
    updateDomIdList: ["fabrique-cart-page-container"],
  },
];
window.recentlyViewedKey = "recently-viewed-v2";
window.productPageActivityCountdownTimer = null;
window.fabriqueHomeDesignerSwiper = null;

class FabriqueModal extends HTMLElement {
  constructor() {
    super();
  }

  show(params) {
    window.setPageScrollStatus(false);
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.opacity = params?.opacity || 0.5;
    this.classList.add("fabrique-modal");
    this.classList.add("fabrique-modal-enter");
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 200);
  }
  hide() {
    this.classList.add("fabrique-modal-leave");
    setTimeout(() => {
      this.classList.remove("fabrique-modal");
      this.classList.remove("fabrique-modal-leave");
    }, 200);
    window.setPageScrollStatus(true);
  }
}

class FabriqueImagePreview extends HTMLElement {
  constructor() {
    super();
    const loop = this.getAttribute("data-loop");
    if (loop) {
      this.loop = !!Number(loop);
    } else {
      this.loop = true;
    }
    this.addEventListener("click", this.handleClick.bind(this));
    this.fabriqueImagePreviewDialogElement = document.querySelector(
      "fabrique-image-preview-dialog"
    );
  }

  handleClick(e) {
    const targetElement = e.target;
    const targetElementTagName = targetElement.tagName.toLowerCase();
    if (!["img", "video", 'artisanimg'].includes(targetElementTagName)) return;

    if (targetElement.hasAttribute("data-fabrique-image-preview-orientation")) {
      $(".fabrique-image-preview-dialog").addClass(
        "fabrique-image-preview-orientation"
      );
    } else {
      $(".fabrique-image-preview-dialog").removeClass(
        "fabrique-image-preview-orientation"
      );
    }
    if (
      targetElement.hasAttribute("data-fabrique-image-preview") ||
      targetElement.hasAttribute("data-fabrique-image-preview-video-poster")
    ) {
      if (targetElementTagName === "video") {
        targetElement.pause();
        window.currentClickPauseVideoElement = targetElement;
      }
      const previewElementList = this.querySelectorAll(
        `[data-fabrique-image-preview]`
      );
      let clickImageIndex = Array.from(previewElementList).indexOf(e.target);
      if (this.loop) {
        clickImageIndex += 1;
      }
      const swiperWrapper = document.querySelector(
        "fabrique-image-preview-dialog .swiper-wrapper"
      );
      swiperWrapper.innerHTML = "";
      previewElementList.forEach((previewElementItem, index) => {
        let src = previewElementItem.getAttribute("src");
        const poster = previewElementItem.getAttribute("poster");
        const swiperSlideElement = document.createElement("div");
        swiperSlideElement.classList.add("swiper-slide");
        const tagName = previewElementItem.tagName.toLowerCase();
        if (["img", "video", 'artisanimg'].includes(tagName)) {
          let element = "";
          if (tagName === "img" || tagName === "artisanimg") {
            swiperSlideElement.setAttribute("data-type", "img");
            element = document.createElement("img");
            element.loading = "lazy";
            if (
              previewElementItem.hasAttribute(
                "data-fabrique-image-preview-common-src"
              ) &&
              previewElementItem.getAttribute(
                "data-fabrique-image-preview-common-src"
              )
            ) {
              src = previewElementItem.getAttribute(
                "data-fabrique-image-preview-common-src"
              );
            }
            if ($(window).width() <= 767) {
              if (
                previewElementItem.hasAttribute(
                  "data-fabrique-image-preview-mobile-src"
                ) &&
                previewElementItem.getAttribute(
                  "data-fabrique-image-preview-mobile-src"
                )
              ) {
                src = previewElementItem.getAttribute(
                  "data-fabrique-image-preview-mobile-src"
                );
              }
            } else {
              if (
                previewElementItem.hasAttribute(
                  "data-fabrique-image-preview-pc-src"
                ) &&
                previewElementItem.getAttribute(
                  "data-fabrique-image-preview-pc-src"
                )
              ) {
                src = previewElementItem.getAttribute(
                  "data-fabrique-image-preview-pc-src"
                );
              }
            }
          }
          if (tagName === "video") {
            swiperSlideElement.setAttribute("data-type", "video");
            element = document.createElement("video");
            element.controls = true;
            element.muted = true;
            element.loop = true;
            element.disablePictureInPicture = true;
            element.playsinline = true;
            element.disableremoteplayback = true;
            element["x5-playsinline"] = true;
            element["webkit-playsinline"] = true;
            element.classList.add("fabrique-image-preview-dialog_video-item");
          }
          element.classList.add("fabrique-image-preview-dialog_image-item");
          element.src = src;
          if (targetElement.hasAttribute("data-carousel")) {
            element.classList.add("fabrique-image-preview-dialog-proudct-gtmClass");
            element.setAttribute('data-index', index + 1);
          }
          element.poster = poster;
          swiperSlideElement.append(element);
          swiperWrapper.append(swiperSlideElement);
        }
      });
      this.fabriqueImagePreviewDialogElement.open();
      window.fabriqueImagePreviewDialogSwiper = new Swiper(
        ".fabrique-image-preview-dialog_swiper",
        {
          loop: this.loop,
          slidesPerView: 1,
          centeredSlides: true,
          pagination: {
            el: ".fabrique-image-preview-dialog-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".fabrique-image-preview-dialog-button-next",
            prevEl: ".fabrique-image-preview-dialog-button-prev",
          },
          on: {
            slideChange: function () {
              const currentSlide = this.slides[this.activeIndex];
              const type = currentSlide.getAttribute("data-type");
              if (this.pagination.el) {
                if (type === "video") {
                  this.pagination.el.style.visibility = "hidden";
                } else if (type === "img") {
                  this.pagination.el.style.visibility = "visible";
                }
              }
            },
            slideChangeTransitionEnd: function () {
              const currentSlide = this.slides[this.activeIndex];
              const videoElement = currentSlide.querySelector("video");
              if (videoElement) {
                videoElement.play();
              }
            },
          },
        }
      );
      window.fabriqueImagePreviewDialogSwiper.slideTo(clickImageIndex, 0);
      // 点击的视频封面图，播放视频
      if (
        targetElement.hasAttribute("data-fabrique-image-preview-video-poster")
      ) {
        document
          .querySelector(".fabrique-image-preview-dialog_swiper video")
          .play();
      }
    }
  }
}

class FabriqueImagePreviewDialog extends HTMLElement {
  constructor() {
    super();
    this.maskElement = this.querySelector(
      ".fabrique-image-preview-dialog_mask"
    );
    this.maskElement.addEventListener("click", (event) => {
      event.stopPropagation();
      this.close();
    });
    this.closeElement = this.querySelector(
      ".fabrique-image-preview-dialog_close"
    );
    this.closeElement.addEventListener("click", (event) => {
      event.stopPropagation();
      this.close();
    });
    this.addEventListener("keyup", (event) => {
      this.close();
    });

    this.addEventListener("click", (event) => {
      this.pauseVideo(event);
    });
  }

  open() {
    window.setPageScrollStatus(false);
    this.handleSwiperPagination();
    this.style.display = "block";
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }
  close() {
    window.fabriqueImagePreviewDialogSwiper.destroy();
    window.fabriqueImagePreviewDialogSwiper = null;
    const swiperWrapper = document.querySelector(
      "fabrique-image-preview-dialog .swiper-wrapper"
    );
    swiperWrapper.innerHTML = "";
    this.style.display = "none";
    window.setPageScrollStatus(true);
    removeTrapFocus(this);
    window.currentClickPauseVideoElement?.play();
    window.currentClickPauseVideoElement = null;
  }
  pauseVideo(e) {
    const targetElement = e.target;
    const targetElementTagName = targetElement.tagName.toLowerCase();
    const videoElements = this.querySelectorAll("video");
    if (targetElementTagName !== "video") {
      videoElements.forEach((videoElement) => {
        videoElement.pause();
      });
    }
  }

  handleSwiperPagination() {
    const swiperSlideLength = this.querySelectorAll(".swiper-slide").length;
    if (swiperSlideLength < 2) {
      $(this.querySelector(".fabrique-image-preview-dialog-button-next")).css({
        visibility: "hidden",
      });
      $(this.querySelector(".fabrique-image-preview-dialog-button-prev")).css({
        visibility: "hidden",
      });
    } else {
      $(this.querySelector(".fabrique-image-preview-dialog-button-next")).css({
        visibility: "initial",
      });
      $(this.querySelector(".fabrique-image-preview-dialog-button-prev")).css({
        visibility: "initial",
      });
    }
  }
}

class FabriqueFabs extends HTMLElement {
  constructor() {
    super();
    this.articleId = this.getAttribute("data-article-id");
    this.articleSpuId = this.getAttribute("data-article-spuid");
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueFabsMedia = this.querySelector("fabrique-fabs-media");
    this.fabriqueFabsPopup = this.querySelector("fabrique-fabs-popup");
    this.fabriqueFabsPopupMask = this.querySelector("fabrique-fabs-popup-mask");
    this.fabriqueFabsPopupVideo = this.fabriqueFabsPopup.querySelector("video");
    this.fabriqueFabsPopupCloseIcon = this.querySelector(
      "fabrique-fabs-popup-close-icon"
    );
    this.fabriqueFabsPopupMask.addEventListener(
      "click",
      this.handleFabriqueFabsPopupMaskCLick.bind(this)
    );
    this.fabriqueFabsMedia.addEventListener(
      "click",
      this.handleFabsMediaClick.bind(this)
    );
    this.fabriqueFabsPopupCloseIcon.addEventListener(
      "click",
      this.handleFabriqueFabsPopupCloseIconLick.bind(this)
    );
    this.addEventListener(
      "keyup",
      this.handleFabriqueFabsPopupClose.bind(this)
    );
  }
  handleFabsMediaClick(e) {
    window.currentClickfabriqueFabs = this;
    const videoElements = document.querySelectorAll(
      "fabrique-fabs-media video"
    );
    videoElements.forEach((videoElementsItem) => {
      if (!videoElementsItem.paused && !videoElementsItem.ended) {
        videoElementsItem.pause();
        window.currentClickPauseVideoElement = videoElementsItem;
      }
    });
    this.removeChild(this.fabriqueFabsPopup);
    document.body.append(this.fabriqueFabsPopup);
    if (this.articleSpuId) {
      const fabriqueFabsPopupSpusSwiper = new Swiper(
        `.fabrique-fabs-popup_spus-swiper-${this.articleId}`,
        {
          direction: "horizontal", // 设置滑动方向为水平
          slidesPerView: "auto", // 自动调整每个滑块的宽度
          freeMode: true, // 启用自由模式,允许用户拖拽滚动
          mousewheel: {
            forceToAxis: true,
          },
          grabCursor: true, // 鼠标悬停时显示抓手图标
          scrollbar: {
            el: ".fabrique-fabs-popup_spus-swiper .swiper-scrollbar",
            draggable: true,
          },
        }
      );
      if (fabriqueFabsPopupSpusSwiper.slides?.length) {
        window.fabriqueFabsPopupSpusSwiper = fabriqueFabsPopupSpusSwiper;
      }
    }
    this.fabriqueModal.show();
    this.fabriqueFabsPopup.show();
    const fabriqueFabsPopupArticleSwiper = new Swiper(
      `.fabrique-fabs-popup_article-swiper-${this.articleId}`,
      {
        pagination: {
          el: ".fabrique-fabs-popup_article-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".fabrique-fabs-popup_article-swiper-button-next",
          prevEl: ".fabrique-fabs-popup_article-swiper-button-prev",
        },
      }
    );
    if (fabriqueFabsPopupArticleSwiper.slides?.length) {
      window.fabriqueFabsPopupArticleSwiper = fabriqueFabsPopupArticleSwiper;
    }
    this.fabriqueFabsPopupVideo && this.fabriqueFabsPopupVideo.play();
    this.focus();
  }
  handleFabriqueFabsPopupMaskCLick(e) {
    const targetElement = e?.target;
    const targetElementTagName = targetElement?.tagName?.toLowerCase();
    if (targetElementTagName !== "fabrique-fabs-popup-mask") return;
    this.handleFabriqueFabsPopupClose();
  }
  handleFabriqueFabsPopupCloseIconLick() {
    this.handleFabriqueFabsPopupClose();
  }
  handleFabriqueFabsPopupClose() {
    window.currentClickfabriqueFabs = null;
    window.fabriqueFabsPopupArticleSwiper?.destroy();
    window.fabriqueFabsPopupArticleSwiper = null;
    window.fabriqueFabsPopupSpusSwiper?.destroy();
    window.fabriqueFabsPopupSpusSwiper = null;
    this.fabriqueFabsPopupVideo && this.fabriqueFabsPopupVideo.pause();
    this.fabriqueModal.hide();
    this.fabriqueFabsPopup.hide();
    window.currentClickPauseVideoElement?.play();
    window.currentClickPauseVideoElement = null;
    setTimeout(() => {
      if (this.fabriqueFabsPopup?.parentNode === document.body) {
         document.body.removeChild(this.fabriqueFabsPopup);
       }
      this.appendChild(this.fabriqueFabsPopup);
    }, 300);
  }
}

class FabriqueFabsMedia extends HTMLElement {
  constructor() {
    super();
  }
}

class FabriqueFabsMediaVideoPoster extends HTMLElement {
  constructor() {
    super();
  }
}

class FabriqueFabsPopupMask extends HTMLElement {
  constructor() {
    super();
  }
}

class FabriqueFabsPopup extends HTMLElement {
  constructor() {
    super();
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    this.classList.add("fabrique-drawer-fade-enter-active");
    setTimeout(() => {
      this.classList.remove("fabrique-drawer-fade-enter-active");
    }, 250);
  }
  hide() {
    this.classList.add("fabrique-drawer-fade-leave-active");
    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-drawer-fade-leave-active");
    }, 250);
  }
}

class FabriqueFabsPopupCloseIcon extends HTMLElement {
  constructor() {
    super();
  }
}
class FabriqueCartProduct extends HTMLElement {
  constructor() {
    super();
    this.$id = this.getAttribute("data-variant-id");
    this.$addElement = this.querySelectorAll("[data-type=add]");
    this.$declineElement = this.querySelectorAll("[data-type=decline]");
    this.$removeElement = this.querySelectorAll("[data-type=remove]");
    this.$quantity = Number(
      this.querySelector("[data-type=quantity]").innerHTML
    );
    this.$errorMessageElement = this.querySelectorAll(
      "[data-type=error-message]"
    );
    this.params = {
      id: this.$id,
      sections: window.updateCartSectionList.map((item) => item.section).join(),
    };
    this.$addElement.forEach((item) => {
      item.addEventListener("click", () => {
        this.handleAddClick();
      });
    });
    this.$declineElement.forEach((item) => {
      item.addEventListener("click", () => {
        this.handleDeclineClick();
      });
    });
    this.$removeElement.forEach((item) => {
      item.addEventListener("click", () => {
        this.handleRomoveClick();
      });
    });
  }

  async handleAddClick() {
    this.showLoading();
    let variantId = this.params.id;
    const dataVariant = $(
      `input[cartItem-data-goods-variant=${variantId}]`
    ).val();
    if (dataVariant && this.$quantity >= dataVariant) {
      let response = {
        status: 422,
        message: "You can't add more to the cart due to limited availability",
      };
      this.handleRenderElement(response);
      this.hideLoading();
      return;
    }
    this.params.quantity = this.$quantity + 1;
    const response = await addCartChangeJs(this.params);
    this.handleRenderElement(response);
    if (!response.status) {
      _learnq.push([
        "track",
        "Added to Cart",
        {
          url: response.items[0].url,
          variant_title: response.items[0].variant_title,
          product_title: response.items[0].product_title,
          image: response.items[0].image,
        },
      ]);
    }
    this.hideLoading();
  }
  async handleDeclineClick() {
    if (this.$quantity !== 1) {
      this.showLoading();
      this.params.quantity = this.$quantity - 1;
      const response = await addCartChangeJs(this.params);
      this.handleRenderElement(response);
      this.hideLoading();
    }
  }
  async handleRomoveClick() {
    this.showLoading();
    this.params.quantity = 0;
    const response = await addCartChangeJs(this.params);
    this.handleRenderElement(response);
    this.hideLoading();
  }
  showLoading() {
    window.setPageScrollStatus(false);
    if (window.location.pathname.includes("/cart")) {
      window.showLoading("", true);
    } else {
      window.showLoading("fabrique-goods-detail-cart-drawer", true);
    }
  }
  hideLoading() {
    window.setPageScrollStatus(true);
    if (window.location.pathname.includes("/cart")) {
      window.showLoading("", false);
    } else {
      window.showLoading("fabrique-goods-detail-cart-drawer", false);
      window.setPageScrollStatus(false);
    }
  }
  handleRenderElement(response) {
    if (response.status) {
      this.$errorMessageElement.forEach((item) => {
        item.innerHTML = response.message;
      });
    } else {
      const sections = response.sections;
      window.updateCartSectionList.forEach((item) => {
        const html = sections[item.section];
        item.updateDomIdList.forEach((domId) => {
          $(`#${domId}`).html(
            new DOMParser()
              .parseFromString(html, "text/html")
              .querySelector(`#${domId}`).innerHTML
          );
          if ($(`#${domId}`).has("*").length) {
            if ($(`#${domId}`).css("display") == "none") {
              $(`#${domId}`).css({
                display: "block",
              });
            }
          } else {
            $(`#${domId}`).css({
              display: "none",
            });
          }
        });
        initAnnouncementSwiper()
      });
    }
  }
}

class FabriqueVideoPreview extends HTMLElement {
  constructor() {
    super();
    this.videoOptions = {
      src: this.getAttribute("data-src"),
      mobileSrc: this.getAttribute("data-mobile-src"),
      loop: this.hasAttribute("data-loop")
        ? Boolean(this.getAttribute("data-loop"))
        : true,
      autoplay: this.hasAttribute("data-autoplay")
        ? Boolean(this.getAttribute("data-autoplay"))
        : true,
      posterPc: this.getAttribute("data-poster-pc"),
      posterMobile: this.getAttribute("data-poster-mobile"),
      controls: this.hasAttribute("data-controls")
        ? this.getAttribute("data-controls")
        : true,
    };

    this.fabriqueVideoPreviewDialogElement = document.querySelector(
      "fabrique-video-preview-dialog"
    );
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    this.fabriqueModal.show({ opacity: 1 });
    this.fabriqueVideoPreviewDialogElement.show({ ...this.videoOptions });
  }
}

class FabriqueVideoPreviewDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueVideoPreviewDialogContentElement = this.querySelector(
      "#fabrique-video-preview-dialog-content"
    );
    this.fabriqueVideoPreviewDialogElement = document.querySelector(
      "#fabrique-video-preview-dialog"
    );
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.videoElement = this.querySelector("video");
    this.addEventListener("keyup", () => {
      this.handleClose();
    });
    this.addEventListener("click", (e) => {
      const targetElementTagName = e.target.tagName.toLowerCase();
      if (["video"].includes(targetElementTagName)) return;
      this.handleClose();
    });
  }

  show(params) {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.videoElement.src = params.src;
    this.videoElement.autoplay = params.autoplay;
    this.videoElement.controls = params.controls;
    this.videoElement.loop = params.loop;
    if ($(window).width() <= 767) {
      this.videoElement.poster = params.posterMobile;
      if (params.mobileSrc) {
        this.videoElement.src = params.mobileSrc;
      }
    } else {
      this.videoElement.poster = params.posterPc;
    }
    this.videoElement.play();
    this.style.display = "block";
    this.fabriqueVideoPreviewDialogElement.focus();
  }
  handleClose() {
    this.fabriqueModal.hide();
    this.videoElement.pause();
    this.style.display = "none";
  }
}

class FabriqueSortItem extends HTMLElement {
  constructor() {
    super();
    this.dataSortOption = this.getAttribute("data-sort-option");
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }
  handleClick() {
    var that = this;
    const $currentSelectSortOptionElements = $(
      ".fabrique-main-collection-product-sort-select-option[selected]"
    );
    const $currentSortOptionElements = $(
      `.fabrique-main-collection-product-sort-select-option[value=${this.dataSortOption}]`
    );
    const currentSelectSortOption =
      $currentSelectSortOptionElements.attr("value");
    if (currentSelectSortOption === this.dataSortOption) return;
    window.showLoading();
    $currentSelectSortOptionElements.each(function () {
      $(this).removeAttr("selected");
    });
    $currentSortOptionElements.each(function () {
      $(this).attr("selected", "selected");
    });
    $(".fabrique-sort-select-item").each(function () {
      $(this).removeClass("fabrique-sort-select-item--active");
      if ($(this).attr("data-sort-option") === that.dataSortOption) {
        $(this).addClass("fabrique-sort-select-item--active");
        $('input[fabrique-sort-by]').val(that.dataSortOption).trigger('change');
      }
    });

    $(".fabrique-sort-h5-content").text(
      {
        manual: "Featured",
        relevance: "Featured",
        "best-selling": "Best Sellers",
        "created-descending": "Newest",
        "price-ascending": "Price:Low to High",
        "price-descending": "Price: High to Low",
      }[this.dataSortOption]
    );
    document
      .querySelector(".fabrique-main-collection-product-sort-select")
      .dispatchEvent(new Event("change"));
  }
}

class FabriqueLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.country_code_input = this.querySelector('input[name="country_code"]');
    this.country_elements = this.querySelectorAll("div[data-country-iso-code]");
    this.country_elements.forEach((country_element) =>
      country_element.addEventListener("click", () =>
        this.handleCountryElementClick(country_element)
      )
    );
  }

  handleCountryElementClick(country_element) {
    $(this.country_code_input).attr(
      "value",
      $(country_element).attr("data-country-iso-code")
    );
    this.form.submit();
  }
}

class FabriqueLocalizationHeaderIcon extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueLocalizationDialog = document.querySelector(
      "fabrique-localization-dialog"
    );
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    this.fabriqueModal.show();
    this.fabriqueLocalizationDialog.show();
  }
}

class FabriqueLocalizationDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
    window.addEventListener("resize", (e) => {
      if ($(window).width() <= 767) {
        this.hide();
      }
    });
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    this.classList.add("fabrique-modal-enter");
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 250);
  }

  hide() {
    this.fabriqueModal.hide();
    this.classList.add("fabrique-modal-leave");
    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-modal-leave");
    }, 250);
  }

  handleClick(e) {
    const $target = $(e.target);
    const $maskElement = $target.closest("#fabrique-localization-dialog-mask");
    const $closeElement = $target.closest(
      "#fabrique-localization-dialog-close"
    );
    if ($maskElement.length || $closeElement.length) {
      this.hide();
    }
  }
}

class FabriqueTryOnIcon extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueTryOnDialog = document.querySelector(
      "fabrique-try-on-dialog"
    );
    this.fabriqueElements = {
      content: document.querySelectorAll(".fabrique-try-on-dialog-content"),
      upload: document.querySelectorAll(".fabrique-try-on-dialog-upload-action"),
      submit: document.querySelectorAll(".fabrique-try-on-button-submit"),
      delete: document.querySelectorAll(".fabrique-try-on-dialog-button-delete"),
      download: document.querySelector("#fabrique-try-on-dialog-generating-download-action"),
      gtmclass: document.querySelectorAll(".fabrique-try-on-dialog-close-gtmclass") // 改为类选择器
    };
    this.fabriqueTryOnNumber = document.querySelectorAll('.fabrique-try-on-number')
    this.fabriqueTryOnContentImg = document.querySelectorAll('.fabrique-try-on-dialog-content-image')
    this.addEventListener("click", () => {
      let dataHandle = this.getAttribute("data-handle")
      let dataTitle = this.getAttribute("data-title")
      this.handleClick(dataHandle, dataTitle);
    });

  }



  handleClick(dataHandle, dataTitle) {
    this.handletryOnValidate(dataHandle, dataTitle);
  }
  async handletryOnValidate(dataHandle, dataTitle) {
    const tryOnData = await window.tryOnValidate(dataHandle);
    if (tryOnData && tryOnData.isCan) {
      this.fabriqueTryOnNumber.forEach((element) => {
        element.innerHTML = tryOnData.dailyCount
      })
      const handleParts = dataHandle.split('-');
      const spuIdText = handleParts[handleParts.length - 1].trim();
      $('input[data-good-spuId]').val(spuIdText);
      this.fabriqueTryOnContentImg.forEach((element) => {
        element.src = tryOnData.spuModelImage + '?x-oss-process=image/format,webp/quality,Q_80/resize,w_1000'
      })
      Object.entries(this.fabriqueElements).forEach(([key, element]) => {
        if (element instanceof Element) {
          element?.setAttribute('data-title', dataTitle);
        } else if (element instanceof NodeList) {
          element.forEach(el => el?.setAttribute('data-title', dataTitle));
        }
      });
      this.fabriqueModal.show();
      this.fabriqueTryOnDialog.show();
    } else {
      window.showToast('Try-On has reached the limits, please try again Tomorrow.”');
      window.location.reload();
    }
  }
}

class FabriqueTryOnDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueTryOnclose = document.querySelectorAll('.fabrique-try-on-dialog-close-gtmclass')


    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    this.classList.add("fabrique-modal-enter");
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 250);
  }

  hide() {
    this.fabriqueModal.hide();
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    this.classList.add("fabrique-modal-leave");
    this.fabriqueTryOnclose.forEach(element => {
      if (element.hasAttribute("data-process")) {
        element.removeAttribute("data-process");
      }
    });

    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-modal-leave");
    }, 250);
  }

  handleClick(e) {
    const $target = $(e.target);
    const $maskElement = $target.closest("#fabrique-try-on-dialog-mask");
    const $closeElement = $target.closest(
      "#fabrique-try-on-dialog-close"
    );
    if ($maskElement.length || $closeElement.length) {
      this.hide();
    }
  }
}

class FabriqueShopTheLookIcon extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueLocalizationDialog = document.querySelector(
      "fabrique-shop-the-look-dialog"
    );
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    this.fabriqueModal.show();
    this.fabriqueLocalizationDialog.show();
  }
}

class FabriqueShopTheLookDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
    window.addEventListener("resize", (e) => {
      if ($(window).width() <= 767) {
        this.hide();
      }
    });
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    this.classList.add("fabrique-modal-enter");
    this.setHeight()
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 250);
  }

  hide() {
    this.fabriqueModal.hide();
    this.classList.add("fabrique-modal-leave");
    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-modal-leave");
    }, 250);
  }
  setHeight() {
    const parent = document.querySelector('fabrique-shop-the-look-dialog');
    const elements = parent ? parent.querySelectorAll('.variant-preorder-time--show') : [];
    if (elements.length === 0) return;
    let maxHeight = 0;
    elements.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.clientHeight);
    });
    const target = parent.querySelectorAll('.fabrique-goods-product-preorder-time');
    target.forEach((el) => {
      el.style.height = maxHeight ? `${maxHeight}px` : '0';
    })
  }
  handleClick(e) {
    const $target = $(e.target);
    const $maskElement = $target.closest("#fabrique-shop-the-look-dialog-mask");
    const $closeElement = $target.closest(
      "#fabrique-shop-the-look-dialog-close"
    );
    if ($maskElement.length || $closeElement.length) {
      this.hide();
    }
  }
}



class FabriqueCustomsRequirementIcon extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueCustomsRequirementDialog = document.querySelector(
      "fabrique-customs-requirement-dialog"
    );
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    this.fabriqueModal.show();
    this.fabriqueCustomsRequirementDialog.show();
  }
}

class FabriqueCustomsRequirementDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueTextarea = document.getElementById('fabrique-customs-requirement-textarea');
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
    window.addEventListener("resize", (e) => {
      if ($(window).width() <= 767) {
        this.hide();
      }
    });
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    this.classList.add("fabrique-modal-enter");
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 250);
  }

  hide() {
    this.fabriqueModal.hide();
    this.classList.add("fabrique-modal-leave");
    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-modal-leave");
    }, 250);
    const FabriqueidInput = document.getElementById("fabrique_customs_id_number");
    const FabriquenameInput = document.getElementById("fabrique_customs_chinese_name");
    const FabriquehiddenNote = document.getElementById("fabrique-customs-hidden-note");
    const FabriqueButton = document.getElementById('fabrique-customs-requirement-checkout');

    FabriqueidInput.value = "";   // 清空输入框
    FabriquenameInput.value = "";   // 清空输入框
    FabriquehiddenNote.value = "";   // 清空输入框
    FabriqueButton.disabled = true; // 按钮禁用

  }
  handleClick(e) {
    const $target = $(e.target);
    const $maskElement = $target.closest("#fabrique-customs-requirement-mask");
    const $closeElement = $target.closest(
      "#fabrique-customs-requirement-close"
    );
    if ($maskElement.length || $closeElement.length) {
      this.hide();
    }
  }
}


class FabriqueGoodsCartMultipleButton extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.fabriqueGoodsCartMultiplDialog = document.querySelector(
      "fabrique-goods-cart-multiple-dialog"
    );
    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    const images = this.dataset.images
      ? this.dataset.images.split(',').filter(Boolean).slice(0, 3)
      : [];
    this.fabriqueGoodsCartMultiplDialog.setImages(images);
    this.fabriqueModal.show();
    this.fabriqueGoodsCartMultiplDialog.show();
  }
}

class FabriqueGoodsCartMultiplDialog extends HTMLElement {
  constructor() {
    super();
    this.fabriqueModal = document.querySelector("fabrique-modal");
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
    window.addEventListener("resize", (e) => {
      if ($(window).width() <= 767) {
        this.hide();
      }
    });
  }

  show() {
    window.modal_index += 1;
    this.style.zIndex = window.modal_index;
    this.style.display = "block";
    this.classList.add("fabrique-modal-enter");
    setTimeout(() => {
      this.classList.remove("fabrique-modal-enter");
    }, 250);
  }

  setImages(images) {
    const container = this.querySelector('.fabrique-goods-cart-multiple-images');
    if (!container) return;
    container.innerHTML = ''; // 清空旧内容
    images.forEach((src) => {
      const img = document.createElement('img');
      img.src = src;
      img.className = 'fabrique-goods-cart-multiple-image';
      img.loading = 'lazy';
      container.appendChild(img);
    });
  }

  hide() {
    this.fabriqueModal.hide();
    this.classList.add("fabrique-modal-leave");
    setTimeout(() => {
      this.style.display = "none";
      this.classList.remove("fabrique-modal-leave");
    }, 250);
  }
  handleClick(e) {
    const $target = $(e.target);
    const $maskElement = $target.closest("#fabrique-goods-cart-multiple-mask");
    const $closeElement = $target.closest(
      "#fabrique-goods-cart-multiple-close"
    );
    if ($maskElement.length || $closeElement.length) {
      this.hide();
    }
  }
}


customElements.define("fabrique-modal", FabriqueModal);
customElements.define("fabrique-image-preview", FabriqueImagePreview);
customElements.define(
  "fabrique-image-preview-dialog",
  FabriqueImagePreviewDialog
);
customElements.define("fabrique-fabs", FabriqueFabs);
customElements.define("fabrique-fabs-media", FabriqueFabsMedia);
customElements.define(
  "fabrique-fabs-media-video-poster",
  FabriqueFabsMediaVideoPoster
);
customElements.define("fabrique-fabs-popup-mask", FabriqueFabsPopupMask);
customElements.define("fabrique-fabs-popup", FabriqueFabsPopup);
customElements.define(
  "fabrique-fabs-popup-close-icon",
  FabriqueFabsPopupCloseIcon
);
customElements.define("fabrique-cart-product", FabriqueCartProduct);
customElements.define("fabrique-video-preview", FabriqueVideoPreview);
customElements.define(
  "fabrique-video-preview-dialog",
  FabriqueVideoPreviewDialog
);
customElements.define("fabrique-sort-item", FabriqueSortItem);
customElements.define("fabrique-localization-form", FabriqueLocalizationForm);
customElements.define(
  "fabrique-localization-header-icon",
  FabriqueLocalizationHeaderIcon
);
customElements.define(
  "fabrique-localization-dialog",
  FabriqueLocalizationDialog
);
customElements.define(
  "fabrique-try-on-icon",
  FabriqueTryOnIcon
);
customElements.define(
  "fabrique-try-on-dialog",
  FabriqueTryOnDialog
);
customElements.define(
  "fabrique-shop-the-look-icon",
  FabriqueShopTheLookIcon
);
customElements.define(
  "fabrique-shop-the-look-dialog",
  FabriqueShopTheLookDialog
);
customElements.define(
  "fabrique-customs-requirement-icon",
  FabriqueCustomsRequirementIcon
);
customElements.define(
  "fabrique-customs-requirement-dialog",
  FabriqueCustomsRequirementDialog
);

customElements.define(
  "fabrique-goods-cart-multiple-button",
  FabriqueGoodsCartMultipleButton
);
customElements.define(
  "fabrique-goods-cart-multiple-dialog",
  FabriqueGoodsCartMultiplDialog
);


